/* global  */ // tUrl等のグローバル変数を宣言する
// import { forEach } from 'core-js/fn/array'
import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function ($) {
  if ($('.MV-swiper__container')[0]) {
    // リクルート
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const voiceSwiper = new Swiper('.MV-swiper__container', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 1500, // アニメ速度
      loop: true, // ループ
      loopAdditionalSlides: 3, //ループ演出用のクローン数を増やして安定化させる
      centeredSlides: true,
      slidesPerView: 1, //表示数変更
      autoplay: {
        delay: 5000, // 待機時間
        disableOnInteraction: false // 操作されたらオート解除
      },
      navigation: {
        nextEl: '.MV-swiper-button-next',
        prevEl: '.MV-swiper-button-prev'
      },
      pagination: {
        el: '.MV-swiper-pagination',
        type: 'fraction'
      }
    })
  }
  // ########  #######  ########  ########  ######## ##    ##
  //    ##    ##     ## ##     ## ##     ##    ##    ###   ##
  //    ##    ##     ## ##     ## ##     ##    ##    ####  ##
  //    ##    ##     ## ########  ########     ##    ## ## ##
  //    ##    ##     ## ##        ##     ##    ##    ##  ####
  //    ##    ##     ## ##        ##     ##    ##    ##   ###
  //    ##     #######  ##        ########     ##    ##    ##
  $(window).scroll(function () {
    if ($(window).scrollTop() > 600) {
      $('.page-top').addClass('fixed')
    } else {
      $('.page-top').removeClass('fixed')
    }
  })
  // ########    ###    ########  ########         #### ##    ##
  // ##         ## ##   ##     ## ##                ##  ###   ##
  // ##        ##   ##  ##     ## ##                ##  ####  ##
  // ######   ##     ## ##     ## ######   #######  ##  ## ## ##
  // ##       ######### ##     ## ##                ##  ##  ####
  // ##       ##     ## ##     ## ##                ##  ##   ###
  // ##       ##     ## ########  ########         #### ##    ##
  function fadeinanime() {
    if (window.matchMedia('(min-width: 600px)').matches) {
      $('.fade-in').each(function () {
        var position = $(this).offset().top
        var scroll = $(window).scrollTop() //スクロールした量を計測して変数に代入
        var windowHeight = $(window).height() //ウィンドウの高さを取得して代入する
        if (scroll > position - windowHeight + 150) {
          //スクロールした分＞（下から出す要素の高さ-ウィンドウの高さ）＋位置の調整
          $(this).addClass('active') //超過したときに該当のクラスにstopを追加
        }
      })
    } else {
      //600px以下の場合
      $('.fade-in').each(function () {
        var position = $(this).offset().top
        var scroll = $(window).scrollTop() //スクロールした量を計測して変数に代入
        var windowHeight = $(window).height() //ウィンドウの高さを取得して代入する
        if (scroll > position - windowHeight + 50) {
          //スクロールした分＞（下から出す要素の高さ-ウィンドウの高さ）＋位置の調整
          $(this).addClass('active') //超過したときに該当のクラスにstopを追加
        }
      })
    }
  }
  //スクロール時とページ読み込み時にfadeinanime関数を発火させる
  $(window).scroll(function () {
    //スクロール時に一度だけ行う処理
    //600px以上の場合
    fadeinanime()
  })
  $(document).ready(function () {
    fadeinanime()
  })
  // ######## ########  ##     ## ##    ## ##    ##  #######
  //    ##    ##     ## ##     ## ###   ## ##   ##  ##     ##
  //    ##    ##     ## ##     ## ####  ## ##  ##   ##     ##
  //    ##    ########  ##     ## ## ## ## #####     #######
  //    ##    ##   ##   ##     ## ##  #### ##  ##   ##     ##
  //    ##    ##    ##  ##     ## ##   ### ##   ##  ##     ##
  //    ##    ##     ##  #######  ##    ## ##    ##  #######
  function trunk8() {
    $('.js-t8.line3').trunk8({
      // 指定要素に行数制限をかける
      lines: 3,
      fill: '...'
    })
    $('.js-t8.line2').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line1').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
  }
  if ($('.js-t8')[0]) {
    // 要素を検出したら実行
    trunk8()
    $(window).on('load resize ', function () {
      trunk8()
    })
  }
  // チェックボックスのチェックを確認して条件分岐
  if (document.getElementById('douiChk')) {
    $('#douiChk').on('change', function () {
      if (this.checked) {
        // チェックがはいっている
        $('.submit--btn').addClass('active')
      } else {
        // チェックがはいっていない
        $('.submit--btn').removeClass('active')
      }
    })
    if (document.getElementById('douiChk').checked) {
      // チェックがはいっている
      $('.submit--btn').addClass('active')
    } else {
      // チェックがはいっていない
      $('.submit--btn').removeClass('active')
    }
  }
  if (document.getElementById('filebtn')) {
    if (document.getElementById('filebtn').checked) {
      // チェックがはいっている
      document.getElementById('uv').style.display = 'inline-block'
      document.getElementById('uv').value = this.value
    } else {
      // チェックがはいっていない
      $('.submit--btn').removeClass('active')
    }
  }
  /* global Cookies */
  // Cookies.remove('opFlag')
  const opFlag = Cookies.get('opFlag')
  if (opFlag !== 1) {
    Cookies.set('opFlag', 1, { expires: 1 / 24, path: '/' }) //Cookie定義
  }
  let spinwidth = 550
  let spinheight = 500

  $(document).ready(function () {
    if (window.matchMedia('(min-width: 600px)').matches) {
    } else {
      //600px以下の場合
      spinwidth = 350
      spinheight = 300
    }
    $('#SPRIT').spritespin({
      animate: false,
      loop: true,
      width: spinwidth,
      height: spinheight,
      frames: 31,
      /* global tUrl */
      source: [
        tUrl + 'img/sprit/360_1.png',
        tUrl + 'img/sprit/360_2.png',
        tUrl + 'img/sprit/360_3.png',
        tUrl + 'img/sprit/360_4.png',
        tUrl + 'img/sprit/360_5.png',
        tUrl + 'img/sprit/360_6.png',
        tUrl + 'img/sprit/360_7.png',
        tUrl + 'img/sprit/360_8.png',
        tUrl + 'img/sprit/360_9.png',
        tUrl + 'img/sprit/360_10.png',
        tUrl + 'img/sprit/360_11.png',
        tUrl + 'img/sprit/360_12.png',
        tUrl + 'img/sprit/360_13.png',
        tUrl + 'img/sprit/360_14.png',
        tUrl + 'img/sprit/360_15.png',
        tUrl + 'img/sprit/360_16.png',
        tUrl + 'img/sprit/360_17.png',
        tUrl + 'img/sprit/360_18.png',
        tUrl + 'img/sprit/360_19.png',
        tUrl + 'img/sprit/360_20.png',
        tUrl + 'img/sprit/360_21.png',
        tUrl + 'img/sprit/360_22.png',
        tUrl + 'img/sprit/360_23.png',
        tUrl + 'img/sprit/360_24.png',
        tUrl + 'img/sprit/360_25.png',
        tUrl + 'img/sprit/360_26.png',
        tUrl + 'img/sprit/360_27.png',
        tUrl + 'img/sprit/360_28.png',
        tUrl + 'img/sprit/360_29.png',
        tUrl + 'img/sprit/360_30.png',
        tUrl + 'img/sprit/360_31.png'
      ]
    })
  })

  $('.Qtxt').on('click', function () {
    $(this).next('.Atxt').slideToggle()
  })
  $('.SPEC--MAP').on('click', function () {
    $(this).find('.js-hide').slideToggle()
    $(this).find('.font_color').toggleClass('active')
    $(this).find('.WICO').toggleClass('active')
    $(this).next('.js-hide').slideToggle()
    $(this).next('.closeImg').toggleClass('active')
    $(this).find('.closeImg').toggleClass('active')
  })
  $('.js--map--open--btn').on('click', function () {
    $(this).toggleClass('active')
    $(this).next('.js-hide').slideToggle()
    $(this).next('.closeImg').toggleClass('active')
  })

  $('.YAPBTN-b').on('click', function () {
    $(this).addClass('active')
    $(this).siblings('.YAPBTN-b').removeClass('active')
  })
  ////EDiとATS用
  $('.js--USER-BTN').on('click', function () {
    $(this).parents('.YAPBTN').siblings('.PART--mode').removeClass('active')
    $(this).parents('.YAPBTN').siblings('.User--mode').addClass('active')
  })
  $('.js--PARTN-BTN').on('click', function () {
    $(this).parents('.YAPBTN').siblings('.User--mode').removeClass('active')
    $(this).parents('.YAPBTN').siblings('.PART--mode').addClass('active')
  })

  $('.js-chk-btn').on('click', function () {
    $(this).addClass('active')
    $(this).siblings('.js-chk-btn').removeClass('active')
  })
  $('.js-H-btn').on('click', function () {
    $(this).toggleClass('active')
  })
  $('.js--about--btn').hover(function () {
    $(this).parents('.About_DetailLink').toggleClass('hover')
  })
  $('.js--rec--btn').hover(function () {
    $(this).parents('.link-wrap').toggleClass('hover')
  })
  // ##     ## ########  ##
  // ##     ## ##     ## ##
  // ##     ## ##     ## ##
  // ##     ## ########  ##
  // ##     ## ##   ##   ##
  // ##     ## ##    ##  ##
  //  #######  ##     ## ########

  /* global hUrl */
  var p = $('.pc-flex').hasClass('ness')
  $(document).ready(function () {
    // URLにhogehogeが含まれていたら実行
    if (document.URL.match('entry-thanks') && p === true) {
      location.href = hUrl
    }
  })
  // ##     ##  #######  ########     ###    ##
  // ###   ### ##     ## ##     ##   ## ##   ##
  // #### #### ##     ## ##     ##  ##   ##  ##
  // ## ### ## ##     ## ##     ## ##     ## ##
  // ##     ## ##     ## ##     ## ######### ##
  // ##     ## ##     ## ##     ## ##     ## ##
  // ##     ##  #######  ########  ##     ## #######
  $('.js-youtube__popup').magnificPopup({
    type: 'inline',
    preloader: false
  })
  // ########  #######  ########  ##     ##
  // ##       ##     ## ##     ## ###   ###
  // ##       ##     ## ##     ## #### ####
  // ######   ##     ## ########  ## ### ##
  // ##       ##     ## ##   ##   ##     ##
  // ##       ##     ## ##    ##  ##     ##
  // ##        #######  ##     ## ##     ##
  //ご用件に選択したチェックボックスの内容を反映
  $('input[name="Require"]').change(function () {
    if ($(this).prop('checked')) {
      // value値を出力
      let valueName = $(this).val()
      $('.form-type-select').text(valueName)
      checkType(valueName)
    }
  })
  //入力画面の条件分岐
  function checkType(valueName) {
    if (valueName === '採用について') {
      $('.BusiV').removeClass('active')
      $('.PartV').removeClass('active')
      $('.ProdV').removeClass('active')
      $('.RecV').addClass('active')
      $('.content--line').addClass('active')
      $('.CorpVer').addClass('is-none')
    } else if (valueName === '事業・サービスについて') {
      $('.RecV').removeClass('active')
      $('.PartV').removeClass('active')
      $('.ProdV').removeClass('active')
      $('.BusiV').addClass('active')
      $('.content--line').removeClass('active')
      $('.CorpVer').addClass('ness')
      $('.CorpVer').removeClass('is-none')
    } else if (valueName === 'ビジネスパートナーについて') {
      $('.RecV').removeClass('active')
      $('.BusiV').removeClass('active')
      $('.ProdV').removeClass('active')
      $('.PartV').addClass('active')
      $('.content--line').removeClass('active')
      $('.CorpVer').addClass('ness')
      $('.CorpVer').removeClass('is-none')
    } else if (valueName === '製品について') {
      $('.RecV').removeClass('active')
      $('.BusiV').removeClass('active')
      $('.PartV').removeClass('active')
      $('.ProdV').addClass('active')
      $('.content--line').addClass('active')
      $('.CorpVer').addClass('ness')
      $('.CorpVer').removeClass('is-none')
    } else if (valueName === 'その他') {
      $('.RecV').removeClass('active')
      $('.BusiV').removeClass('active')
      $('.PartV').removeClass('active')
      $('.ProdV').removeClass('active')
      $('.content--line').removeClass('active')
      $('.CorpVer').removeClass('ness')
      $('.CorpVer').removeClass('is-none')
    }
  }
  //確認画面の条件分岐
  let confarea = $('.mw_wp_form').hasClass('mw_wp_form_confirm')
  if (confarea) {
    let jouken = $('input[name="Require"]').val()
    $('.form-type-select').text(jouken)
    if (jouken === '採用について') {
      $('.BusiV').removeClass('active')
      $('.PartV').removeClass('active')
      $('.ProdV').removeClass('active')
      $('.RecV').addClass('active')
      $('.content--line').addClass('active')
      $('.CorpVer').removeClass('ness')
      $('.CorpVer').addClass('is-none')
    } else if (jouken === '事業・サービスについて') {
      $('.RecV').removeClass('active')
      $('.PartV').removeClass('active')
      $('.ProdV').removeClass('active')
      $('.BusiV').addClass('active')
      $('.content--line').removeClass('active')
      $('.CorpVer').addClass('ness')
      $('.CorpVer').removeClass('is-none')
    } else if (jouken === 'ビジネスパートナーについて') {
      $('.RecV').removeClass('active')
      $('.BusiV').removeClass('active')
      $('.ProdV').removeClass('active')
      $('.PartV').addClass('active')
      $('.content--line').removeClass('active')
      $('.CorpVer').addClass('ness')
      $('.CorpVer').removeClass('is-none')
    } else if (jouken === '製品について') {
      $('.RecV').removeClass('active')
      $('.BusiV').removeClass('active')
      $('.PartV').removeClass('active')
      $('.ProdV').addClass('active')
      $('.content--line').addClass('active')
      $('.CorpVer').addClass('ness')
      $('.CorpVer').removeClass('is-none')
    } else if (jouken === 'その他') {
      $('.RecV').removeClass('active')
      $('.BusiV').removeClass('active')
      $('.PartV').removeClass('active')
      $('.ProdV').removeClass('active')
      $('.content--line').removeClass('active')
      $('.CorpVer').removeClass('ness')
      $('.CorpVer').removeClass('is-none')
    }
  }
  let inputarea = $('.mw_wp_form').hasClass('mw_wp_form_input')
  //ページのリロード時の処理
  if (inputarea) {
    $('input[name="Require"]').each(function () {
      //input[name="Require"]は配列、eachとthisで値を取得
      if ($(this).prop('checked')) {
        // value値を出力
        let valueName = $(this).val()
        $('.form-type-select').text(valueName)
        checkType(valueName)
        //↓この一行で、ページリロード時にチェックの入っていたボックスの親要素にactiveを付ける事ができる。
        //.propは.changeとは異なり、ボックスの状態をリアルタイムで監視可能。.changeはチェックアクションがあったとき限定
        $(this).parents('.mwform-radio-field').addClass('active')
      }
    })
    //下記で採用についてのチェックボックスのリロード時の記述ができる。
    $('input[name="RecType"]').each(function () {
      //input[name="Require"]は配列、eachとthisで値を取得
      if ($(this).prop('checked')) {
        // value値を出力
        $(this).parents('.mwform-radio-field').addClass('active')
      }
    })
    $('input[name="BusiType"]').each(function () {
      //input[name="Require"]は配列、eachとthisで値を取得
      if ($(this).prop('checked')) {
        // value値を出力
        $(this).parents('.mwform-radio-field').addClass('active')
      }
    })
    $('input[name="PartType"]').each(function () {
      //input[name="Require"]は配列、eachとthisで値を取得
      if ($(this).prop('checked')) {
        // value値を出力
        $(this).parents('.mwform-radio-field').addClass('active')
      }
    })
    $('input[name="ProdType"]').each(function () {
      //input[name="Require"]は配列、eachとthisで値を取得
      if ($(this).prop('checked')) {
        // value値を出力
        $(this).parents('.mwform-radio-field').addClass('active')
      }
    })
    $('input[name="TypeCont"]').each(function () {
      //input[name="Require"]は配列、eachとthisで値を取得
      if ($(this).prop('checked')) {
        // value値を出力
        $(this).parents('.mwform-radio-field').addClass('active')
      }
    })
    $('input[name="Typedeti"]').each(function () {
      //input[name="Require"]は配列、eachとthisで値を取得
      if ($(this).prop('checked')) {
        // value値を出力
        $(this).parents('.mwform-radio-field').addClass('active')
      }
    })
  }

  // ########     ###    ########  ####  #######
  // ##     ##   ## ##   ##     ##  ##  ##     ##
  // ##     ##  ##   ##  ##     ##  ##  ##     ##
  // ########  ##     ## ##     ##  ##  ##     ##
  // ##   ##   ######### ##     ##  ##  ##     ##
  // ##    ##  ##     ## ##     ##  ##  ##     ##
  // ##     ## ##     ## ########  ####  #######
  // if($('input[name="ppagree"]').checked) {
  //   $('input[name="ppagree"]').parents('.mwform-checkbox-field').removeClass('active')
  //   $(this).parents('.mwform-checkbox-field').addClass('active')
  // }
  //プライバシーポリシーの装飾を変更
  $('input[name="ppagree"]').change(function () {
    if ($(this).prop('checked')) {
      // value値を出力
      $('input[name="ppagree"]').parents('.mwform-checkbox-field').removeClass('active')
      $(this).parents('.mwform-checkbox-field').addClass('active')
    }
  })
  //ご用件のラジオボタンの装飾を変更
  $('input[name="Require"]').change(function () {
    if ($(this).prop('checked')) {
      // value値を出力
      $('input[name="Require"]').parents('.mwform-radio-field').removeClass('active')
      $(this).parents('.mwform-radio-field').addClass('active')
    }
  })
  //～についてのラジオボタンの装飾を変更
  $('input[name="RecType"]').change(function () {
    if ($(this).prop('checked')) {
      // value値を出力
      $('input[name="RecType"]').parents('.mwform-radio-field').removeClass('active')
      $(this).parents('.mwform-radio-field').addClass('active')
    }
  })
  $('input[name="BusiType"]').change(function () {
    if ($(this).prop('checked')) {
      // value値を出力
      $('input[name="BusiType"]').parents('.mwform-radio-field').removeClass('active')
      $(this).parents('.mwform-radio-field').addClass('active')
    }
  })
  $('input[name="PartType"]').change(function () {
    if ($(this).prop('checked')) {
      // value値を出力
      $('input[name="PartType"]').parents('.mwform-radio-field').removeClass('active')
      $(this).parents('.mwform-radio-field').addClass('active')
    }
  })
  $('input[name="ProdType"]').change(function () {
    if ($(this).prop('checked')) {
      // value値を出力
      $('input[name="ProdType"]').parents('.mwform-radio-field').removeClass('active')
      $(this).parents('.mwform-radio-field').addClass('active')
    }
  })
  //さらに下の詳細
  //お問い合わせの詳細のラジオボタンの装飾を変更
  $('input[name="TypeCont"]').change(function () {
    if ($(this).prop('checked')) {
      // value値を出力
      $('input[name="TypeCont"]').parents('.mwform-radio-field').removeClass('active')
      $(this).parents('.mwform-radio-field').addClass('active')
    }
  })
  //お問い合わせの詳細のラジオボタンの装飾を変更
  $('input[name="Typedeti"]').change(function () {
    if ($(this).prop('checked')) {
      // value値を出力
      $('input[name="Typedeti"]').parents('.mwform-radio-field').removeClass('active')
      $(this).parents('.mwform-radio-field').addClass('active')
    }
  })
})
